import {
    useBuscarPromedioVentaFacturaGrafico,
    useBuscarPromedioArticuloFacturaGrafico,
    useBuscarGananciasGrafico,
    useBuscarVentasTotalesGrafico
} from "../../Scripts/Services/facturacion-service.js"
import React, {useEffect,useState} from "react";
import { SelectButton, Messages, Dropdown } from 'primereact';

import { buscar } from "../../../Commons/Scripts/Utils/Buscar";
import { URL_CATEGORIAS, URL_SUB_CATEGORIAS, URL_FAMILIAS } from "../../../Inventario/Scripts/Utils/constantes";
import { URL_TIENDAS_GRID } from "../Utils/constantes"
import {useTheme} from "../../../Commons/Scripts/Hooks";
import { renderToStaticMarkup } from "react-dom/server";
import * as XLSX from "xlsx";
import {SvgComponent} from "../../../Commons/Scripts/Componentes";
const FiltroValorDefault = { IdSec: null, Descripcion: "Todos" };

const Filters = ({ where, setWhere, tienda, setTienda, opcionesTienda, categoria, setCategoria, opcionesCategoria, subCategoriaWhere, setSubCategoriaWhere, subCategoria, opcionesSubCategoria, setSubCategoria, familiaWhere, setFamiliaWhere, familia, setFamilia, opcionesFamilia }) => {
    const handleChangeTienda = (e) => {
        setTienda(e.value);
        setWhere({ where: { ...where.where, TiendaIdSec: e.value.IdSec } });
    };

    const handleChangeCategoria = (e) => {
        setCategoria(e.value);
        setSubCategoria(FiltroValorDefault);
        setFamilia(FiltroValorDefault);
        setSubCategoriaWhere({ where: { ...subCategoriaWhere.where, CategoriaIdSec: e.value.IdSec } });
        setFamiliaWhere({ where: { ...familiaWhere.where, SubCategoriaIdSec: FiltroValorDefault.IdSec } });
        setWhere({ where: { ...where.where, CategoriaIdSec: e.value.IdSec, SubCategoriaIdSec: FiltroValorDefault.IdSec, FamiliaIdSec: FiltroValorDefault.IdSec } }); // TODO: PENDIENTE EN EL BACKEND
    }

    const handleChangeSubCategoria = (e) => {
        setSubCategoria(e.value);
        setFamilia(FiltroValorDefault);
        setFamiliaWhere({ where: { ...familiaWhere.where, c: e.value.IdSec } });
        setWhere({ where: { ...where.where, SubCategoriaIdSec: e.value.IdSec, FamiliaIdSec: FiltroValorDefault.IdSec } }); // TODO: PENDIENTE EN EL BACKEND
    }

    const handleChangeFamilia = (e) => {
        setFamilia(e.value);
        setWhere({ where: { ...where.where, FamiliaIdSec: e.value.IdSec } }); // TODO: PENDIENTE EN EL BACKEND
    }

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '10px',
            padding: '12px',
            flexFlow: 'columnWrap',
            aligItems: 'center',
        }}>
            <div className="card flex justify-content-center" style={{ marginRight: "5px" }}>
                <span className="p-float-label">
                    <Dropdown
                        inputId="dd-Tienda"
                        value={tienda}
                        onChange={handleChangeTienda}
                        options={opcionesTienda}
                        optionLabel="Descripcion"
                    />
                    <label htmlFor="dd-top">Tienda</label>
                </span>
            </div>
            <div className="card flex justify-content-center" style={{ marginRight: "5px" }}>
                <span className="p-float-label">
                    <Dropdown inputId="dd-Categoria" value={categoria} onChange={handleChangeCategoria} options={opcionesCategoria} optionLabel="Descripcion" />
                    <label htmlFor="dd-Categoria">Categoría</label>
                </span>
            </div>
            <div className="card flex justify-content-center" style={{ marginRight: "5px" }}>
                <span className="p-float-label">
                    <Dropdown inputId="dd-SubCategoria" value={subCategoria} onChange={handleChangeSubCategoria} options={opcionesSubCategoria} optionLabel="Descripcion" />
                    <label htmlFor="dd-SubCategoria">Subcategoría</label>
                </span>
            </div>
            {subCategoria?.IdSec != null && <div className="card flex justify-content-center">
                <span className="p-float-label">
                    <Dropdown inputId="dd-Familia" value={familia} onChange={handleChangeFamilia} options={opcionesFamilia} optionLabel="Descripcion" />
                    <label htmlFor="dd-Familia">Familia</label>
                </span>
            </div>}
        </div>
    );
}


export const GraficosFacturacion = () => {
    const {theme} = useTheme();
    const color = ['#3fb1e3', '#91cc75', '#fac858', '#ee6666'];
    const moneda = window.monedaPredeterminada;
    const labelOptions = {
        show: true,
        rotate: 90,
        align: 'left',
        verticalAlign: 'middle',
        color: '#000',
        fontSize: 12,
        position: 'insideBottom',
    }
    const [where, setWhere] = React.useState({where :{periodo:'mensual'}});
    const [value, setValue] = React.useState(3);
    const [tienda, setTienda] = useState({ IdSec: 0, Descripcion: "Todos" });
    const [opcionesTienda, setOpcionesTienda] = useState([{ IdSec: 0, Descripcion: "Todos" }]);

    const [categoria, setCategoria] = useState(FiltroValorDefault);
    const [opcionesCategoria, setOpcionesCategoria] = useState([FiltroValorDefault]);

    const [subCategoria, setSubCategoria] = useState(FiltroValorDefault);
    const [subCategoriaWhere, setSubCategoriaWhere] = useState({ where: { Estatus: 'A', EsPaginable: false } });
    const [opcionesSubCategoria, setOpcionesSubCategoria] = useState([FiltroValorDefault]);

    const [familia, setFamilia] = useState(FiltroValorDefault);
    const [familiaWhere, setFamiliaWhere] = useState({ where: { Estatus: 'A', EsPaginable: false } });
    const [opcionesFamilia, setOpcionesFamilia] = useState([FiltroValorDefault]);

    useEffect(() => {
        let tiendaWhere = { where: { Estatus: 'A', EsPaginable: false } };

        buscar(URL_TIENDAS_GRID, tiendaWhere).then((data) => {
            const opciones = data.Resultados?.map((item) => {
                return { IdSec: item.id, Descripcion: item.text };
            });

            setOpcionesTienda([...opcionesTienda, ...opciones]);
        });

        let categoriaWhere = { where: { Estatus: 'A', EsPaginable: false } };
        buscar(URL_CATEGORIAS, categoriaWhere).then((data) => {
            const opciones = data.Resultados?.map((item) => {
                return { IdSec: item.IdSec, Descripcion: item.Nombre };
            });
            setOpcionesCategoria([...opcionesCategoria, ...opciones])
        });
    }, []);

    useEffect(() => {
        buscar(URL_SUB_CATEGORIAS, subCategoriaWhere).then((data) => {
            const opcionesDefecto = [FiltroValorDefault];
            const opciones = data.Resultados?.map((item) => {
                return { IdSec: item.IdSec, Descripcion: item.Nombre };
            });
            setOpcionesSubCategoria([...opcionesDefecto, ...opciones])
        });
    }, [subCategoriaWhere]);

    useEffect(() => {
        buscar(URL_FAMILIAS, familiaWhere).then((data) => {
            const opcionesDefecto = [FiltroValorDefault];
            const opciones = data.Resultados?.map((item) => {
                return { IdSec: item.IdSec, Descripcion: item.Nombre };
            });
            setOpcionesFamilia([...opcionesDefecto, ...opciones])
        });
    }, [familiaWhere]);

    const periodos = [
        { name: 'Diario', value: 1 },
        { name: 'Semanal', value: 2 },
        { name: 'Mensual', value: 3 },
        { name: 'Trimestral', value: 4 },
        { name: 'Anual', value: 5 }
    ];
    const {data: promedioVentaFactura} = useBuscarPromedioVentaFacturaGrafico(where);
    const {data: promedioArticuloFactura} = useBuscarPromedioArticuloFacturaGrafico(where);
    const {data: ganancias} = useBuscarGananciasGrafico(where);
    const {data: ventasTotales} = useBuscarVentasTotalesGrafico(where)

    function m(n, d) {
        //Convertir numero => 3,000,000 a 3M
        const x = Math.floor(Math.log10(Math.abs(n)));
        const suffix = ['','k','M','MM','T','P','E'];
        const magnitude = Math.floor(x / 3);
        const scaled = n / Math.pow(10, magnitude * 3);
        const rounded = Math.round(scaled * Math.pow(10, d)) / Math.pow(10, d);

        return rounded + ' ' + suffix[magnitude];
    } 
    function handleChange(value) {
        setValue(value);
        switch(value){
            case 1:
                setWhere({where: {periodo:'diario'}});
                break;
            case 2:
                setWhere({where: {periodo:'semanal'}});
                break;
            case 3:
                setWhere({where: {periodo:'mensual'}});
                break;
            case 4:
                setWhere({where: {periodo:'trimestral'}});
                break;
            case 5:
                setWhere({where: {periodo:'anual'}})
                break;
        }
    }
    function crearDivGrafico(data){
        let dom = document.getElementById('chart_' + data.Titulo);
        if (dom) {
            var chartTemp = echarts.getInstanceByDom(document.getElementById('chart_' + data.Titulo));
            if (chartTemp) {
                chartTemp.dispose();
            }
        } else {
            let chart = document.createElement('div');
            chart.setAttribute('id', 'chart_' + data.Titulo)
            chart.setAttribute('class', 'chart');
            document.getElementById('chart_holder').appendChild(chart);
        }   
    }
    function crearGrafico(data){ 
            crearDivGrafico(data);
            var chartDom = document.getElementById('chart_' + data.Titulo);
            const chart = echarts.init(chartDom,null,{width: '653', height: '300'} );
        const svgString = renderToStaticMarkup(<SvgComponent
            iconName="export"
            fill={theme.color1}
        />);
        const svgDataUrl = `data:image/svg+xml;base64,${btoa(svgString)}`;
            var options = {
                color: color,
                title: {
                    text: data.Titulo,
                    left: 'center',
                    textStyle: {
                        fontStyle: 'normal',
                        fontWeight: 'bolder',
                        fontFamily: 'sans-serif'
                    }
                },
                toolbox: {
                    show: true,
                    feature: {
                        myTool1: {
                            show: true,
                            title: 'exportar',
                            icon: `image://${svgDataUrl}`,
                            onclick: function (){
                                const option = chart.getOption();
                                const source = option.dataset[0].source;
                                const dimensions = option.dataset[0].dimensions;

                                const rows = [dimensions, ...source.map(obj => dimensions.map(dim => obj[dim]))];

                                const ws = XLSX.utils.aoa_to_sheet(rows);
                                const wb = XLSX.utils.book_new();
                                XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

                                XLSX.writeFile(wb, `${data.Titulo || "chart-data"}.xlsx`);
                            }
                        }
                    }
                },
                legend: {
                    orient: 'horizontal',
                    left: 'center',
                    top: 'bottom',
                    show: false
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                },
                dataset: {
                    dimensions: ['periodo', 'Promedio'],
                    source: data.Resultados.map((d) => {
                        return {
                            periodo: d.FechaDesc,
                            Promedio: d.Promedio,
                        }
                    })
                },
                xAxis: { type: 'category', },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        fontSize: 9,
                        formatter: function (params) {
                            if(params >= 1000) return `${moneda} ${m(params,1)}`
                            else return `${moneda} ${Citrus.Convert.toCurrencyNoSimbolo(params)}`                      
                        }
                    },
                },
                // Declare several bar series, each will be mapped
                // to a column of dataset.source by default.
                series:
                    [
                        {
                            type: 'bar',
                            emphasis: {
                                focus: 'series'
                            },
                            label: {
                                ...labelOptions,
                                formatter: function (params) {
                                    return moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(params.value.Promedio)
                                },
                            },
                            tooltip: {
                                valueFormatter: value => moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(value)
                            }
                        },
                    ]
            };
            chart.setOption(options);
    }
    function crearGrafico2(data){ 
        crearDivGrafico(data);
        const svgString = renderToStaticMarkup(<SvgComponent
            iconName="export"
            fill={theme.color1}
        />);
        const svgDataUrl = `data:image/svg+xml;base64,${btoa(svgString)}`;
        var chartDom = document.getElementById('chart_' + data.Titulo);
        const chart = echarts.init(chartDom,null,{width: '653', height: '300'} );
        var options = {
            color: color,
            title: {
                text: data.Titulo,
                left: 'center',
                textStyle: {
                    fontStyle: 'normal',
                    fontWeight: 'bolder',
                    fontFamily: 'sans-serif'
                }
            },
            toolbox: {
                show: true,
                feature: {
                    myTool1: {
                        show: true,
                        title: 'exportar',
                        icon: `image://${svgDataUrl}`,
                        onclick: function (){
                            const option = chart.getOption();
                            const source = option.dataset[0].source;
                            const dimensions = option.dataset[0].dimensions;

                            const rows = [dimensions, ...source.map(obj => dimensions.map(dim => obj[dim]))];

                            const ws = XLSX.utils.aoa_to_sheet(rows);
                            const wb = XLSX.utils.book_new();
                            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

                            XLSX.writeFile(wb, `${data.Titulo || "chart-data"}.xlsx`);
                        }
                    }
                }
            },
            legend: {
                orient: 'horizontal',
                left: 'center',
                top: 'bottom',
                show: false
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                },
            },
            dataset: {
                dimensions: ['periodo', 'Promedio'],
                source: data.Resultados.map((d) => {
                    return {
                        periodo: d.FechaDesc,
                        Promedio: d.Promedio,
                    }
                })
            },
            xAxis: { type: 'category', },
            yAxis: {
                type: 'value',
                axisLabel: {
                    fontSize: 9,
                },
            },
            // Declare several bar series, each will be mapped
            // to a column of dataset.source by default.
            series:
                [
                    {
                        type: 'bar',
                        emphasis: {
                            focus: 'series'
                        },
                        label: {
                            ...labelOptions,
                            formatter: function (params) {
                                return Math.round(params.value.Promedio)
                            },
                        },
                        tooltip: {
                            valueFormatter: value => Math.round(value)
                        }
                    }
                ]
        };
        chart.setOption(options);
    }
    React.useEffect(() => {
        if(promedioVentaFactura){
            crearGrafico(promedioVentaFactura);
        }
    }, [promedioVentaFactura])
    React.useEffect(() => {
        if(promedioArticuloFactura){
            crearGrafico2(promedioArticuloFactura);
        }
    }, [promedioArticuloFactura])
    React.useEffect(() => {
        if(ganancias){
            crearGrafico(ganancias);
        }
    }, [ganancias])
    React.useEffect(() => {
        if(ventasTotales){
            crearGrafico(ventasTotales);
        }
    }, [ventasTotales])
    return (
        <div>
            <SelectButton 
            value={value}
            onChange={(e) => handleChange(e.value)}
            optionLabel='name'
            options= {periodos}
            style={{    
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '10px',
                padding: '12px',
                flexFlow: 'columnWrap',
                aligItems: 'center',}}
            />
            <Filters where={where} setWhere={setWhere} tienda={tienda} setTienda={setTienda} opcionesTienda={opcionesTienda} categoria={categoria} opcionesCategoria={opcionesCategoria} setCategoria={setCategoria} subCategoriaWhere={subCategoriaWhere} setSubCategoriaWhere={setSubCategoriaWhere} subCategoria={subCategoria} opcionesSubCategoria={opcionesSubCategoria} setSubCategoria={setSubCategoria} familiaWhere={familiaWhere} setFamiliaWhere={setFamiliaWhere} familia={familia} setFamilia={setFamilia} opcionesFamilia={opcionesFamilia} />
            <div id="chart_holder" class="card_row"></div>
        </div>        
    )
} 
